$(document).ready(function(){

  // // intelligems pricing structure
  window.addEventListener('ig:ready', () => {
    $('.hidden-options').each(function(){
      $(this).find('option').each(function(){
        var variant_id = $(this).val();
        var $this = $(this);
        if( window.igData.price.getPriceByVariantId(variant_id) != null ){
          var price = (window.igData.price.getPriceByVariantId(variant_id) * 100);
          if( $('#product-main  .row > .content').attr('id') == 'bundle' && !$('body').hasClass('filled_bundle') ){
            var discount = price * shop_config.bundle_discount;
            var discounted_price = price - discount;

            $this.attr('price', discounted_price);
            $this.attr('ind_price', price);
          } else{
            $this.attr('price', price);
          }
        }
      });
    });

    $('.ind_option:first-child .builder .options:last-of-type .option input:checked').click();
    
  });
  

  $('.help[href="#sizeguide"]').magnificPopup({
    type: 'inline'
  });

  $('a.help:not(.help[href="#sizeguide"])').on('click', function(e){
    e.preventDefault();
    var whereto = $(this).attr('href');
  
    if( $(whereto).hasClass('tab-pane') ){
      $('#pdp_infos .nav-item button'+ whereto +'-tab').click();
      whereto = '#pdp_info_content '+ whereto;
    }
    $('html,body').animate({
      scrollTop: $(whereto).offset().top - 90
    }, 700);
    
  });

  let handle = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
  let querystring = window.location.search;

  if( querystring.indexOf('variant') > -1 ){
  	const urlParams = new URLSearchParams(querystring);
  	var variant_id = urlParams.get('variant');
    let $selector = '';

    if( $('#variants').length ){
      $selector = $('#variants');
    } else if( $('#ind_selector').length ) {
      $selector = $('#ind_selector');
    }
    $selector.val(variant_id);

    setTimeout(function(){
      $selector.find('option[value="'+ variant_id +'"]').attr('selected');
      $selector.trigger('change');
    }, 100);

    var colour = $selector.find('option[value="'+ variant_id +'"]').text();
    $('.ind_option .options .option.colour input[value="'+ colour +'"]').trigger('change');

  }

  $('select#variants, #ind_selector').on('change', function(){
    var selected,color;
    selected = color = $(this).find('option:selected').text();


    if( selected.includes('/') ){
      // selected = selected.split('/')[1];
      selected = selected.replace(/^\s+|\s+$/gm,'');
    }
  });

  if( $('.product-reviews .slider').length ){ // page reviews
    $('.product-reviews .slider').slick({
      mobileFirst: true,
      prevArrow: '',
      nextArrow: $('.product-reviews .next'),
      dots: false,
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
          }
        }
      ]
    }).show();

    $('.product-reviews .slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;

      $('.product-reviews .progress').css('background-size', calc + '% 100%').attr('aria-valuenow', calc );
      $('.product-reviews .progress .slider__label').text( calc + '% completed' );
    });
  }

  if( $('.shopify-section.productrecommendations .slider').length ){ // recommendations slider
    $('.shopify-section.productrecommendations .slider').slick({
      mobileFirst: true,
      prevArrow: '',
      nextArrow: $('.shopify-section.productrecommendations .next'),
      dots: false,
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
          }
        }
      ]
    }).show();
  }

  // play video as scroll in
  if( $('.shopify-section.content_sections .video').length ){
    let videos = document.querySelectorAll("video");
    videos.forEach((video) => {
      video.muted = true;
      let playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.then((_) => {
          let observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (
                  entry.intersectionRatio !== 1 &&
                  !video.paused
                ) {
                  video.pause();
                } else if (video.paused) {
                  video.play();
                }
              });
            },
            { threshold: 0.2 }
          );
          observer.observe(video);
        });
      }
    });
  }

  // VIEWPORT FUNCTION
  var inviewport = false

  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  if( $('#shopify-section-product--stats').length ){
    $(window).on('resize scroll', function() {
      if ($('#shopify-section-product--stats').isInViewport()) {
        inviewport = true;
      }

      if( inviewport == true ){
        $('.counter').each(function() {
            var $this = $(this),
                countTo = $this.attr('data-count');

            $({ countNum: $this.text()}).animate({
              countNum: countTo
            },
            {
              duration: 3000,
              easing:'linear',
              step: function() {
                $this.text(Math.floor(this.countNum));
              },
              complete: function() {
                var number = this.countNum;
                $this.text(number);
              }
            });
          });
      }
    });
  }

  if( $('#shopify_section-product--types').length ){
    $('#shopify_section-product--types .slider').slick({
      mobileFirst: true,
      prevArrow: '',
      nextArrow: $('#shopify_section-product--types .next'),
      dots: false,
      responsive: [
        {
          breakpoint: 640,
          settings: 'unslick'
        }
      ]
    }).show();

    $('#shopify_section-product--types .slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;

      $('#shopify_section-product--types .progress').css('background-size', calc + '% 100%').attr('aria-valuenow', calc );
      $('#shopify_section-product--types .progress .slider__label').text( calc + '% completed' );
    });
  }

  if( $('.pillow_types').length ){

    $('.pillow_types .item.density p').matchHeight();
    $('.pillow_types .slider').slick({
      mobileFirst: true,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 640,
          settings: 'unslick'
        }
      ]
    }).show();

    $('.pillow_types .slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;

      $('.pillow_types .progress').css('background-size', calc + '% 100%').attr('aria-valuenow', calc );
      $('.pillow_types .progress .slider__label').text( calc + '% completed' );
    });
  }
});
